import React from 'react';
import T from '@prisjakt/ui-translate';
import PriceLabel from '@prisjakt/ui-price-label';
import * as S from './styles';

type Props = {
  id?: string;
  onClick: () => void;
  text: string;
  selected: boolean;
  index: number;
  price?: number;
  includePriceOnProductSuggestions: boolean;
};

export default ({
  id,
  onClick,
  text,
  selected,
  index,
  includePriceOnProductSuggestions,
  price,
}: Props) => {
  return (
    <S.Item
      onClick={onClick}
      selected={selected}
      style={{ order: index }}
      data-test="SearchSuggestionItem"
    >
      <S.RowInfo>
        <S.IconWrapper>
          <S.Icon src={`https://cdn.pji.nu/product/standard/80/${id}.jpg`} />
        </S.IconWrapper>
        {text}
      </S.RowInfo>
      {!includePriceOnProductSuggestions && (
        <S.DirectLink data-test="DirectLink">
          <T domain="search">suggest.product</T>
        </S.DirectLink>
      )}
      {includePriceOnProductSuggestions && <PriceLabel value={price || null} />}
    </S.Item>
  );
};
